// extracted by mini-css-extract-plugin
module.exports = {"dividedLine":"styles_dividedLine__lu5kq"};